// @ts-check
import { formatQueryRange } from '../utils/common';
import { removeFalseyParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class ReportsAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'reports' });
  }

  /**
   * @param {{}} filters
   * @param {number} [pageNumber]
   * @param {number} [pageSize]
   * @param {string} [sort]
   */
  fetchReports = async (filters = {}, pageNumber, pageSize, sort) => {
    const params = removeFalseyParams({ ...filters, sort });
    const range = formatQueryRange(pageNumber, pageSize);

    const response = await handleApiCalls('get', this.baseUrl, {
      params: { ...params, range },
    });

    return response.data;
  };
  /**
   * @param {string} reportId
   */
  deleteReport = async reportId => {
    const response = await handleApiCalls('delete', this.baseUrl + `/${reportId}`);

    return response.data;
  };
  /**
   * @param {{}} data
   */
  createReport = async data => {
    const response = await handleApiCalls('post', this.baseUrl, data);

    return response.data;
  };
  /**
   * @param {{data:{}, reportId: string}} updateReportParams
   */
  updateReport = async ({ data, reportId }) => {
    const response = await handleApiCalls('put', this.baseUrl + `/${reportId}`, data);

    return response.data;
  };
  /**
   * @param {string} reportId
   */
  fetchReport = async reportId => {
    const response = await handleApiCalls('get', this.baseUrl + `/${reportId}`);

    return response.data;
  };
}

export default ReportsAPI;
